module.exports = __webpack_public_path__ + "static/media/fullscreen-img.f23a0524.svg";